import React from 'react';
import { Badge, Tooltip } from '@chakra-ui/react';

/** Labels a matched or selectable NEX line; return slips use `/returns` only (`orders` kept for legacy rows). */
export function NexMatchSourceBadge({ source }: { source?: 'returns' | 'orders' }) {
    if (source !== 'returns' && source !== 'orders') return null;
    const full = source === 'returns' ? 'Matched from NEX returns' : 'Matched from NEX orders';
    const short = source === 'returns' ? 'returns' : 'orders';
    return (
        <Tooltip label={full} placement="top" hasArrow>
            <Badge colorScheme={source === 'returns' ? 'purple' : 'cyan'} fontSize="10px" ml={1} verticalAlign="middle">
                {short}
            </Badge>
        </Tooltip>
    );
}
